const analyticsObj = {
  new_professional: {
    category: "Professional",
    action: "New Professional",
    label: "New Professional",
  },
  facebook: {
    category: "Social Links",
    action: "Click Social Media FB",
    label: "Facebook",
  },
  instagram: {
    category: "Social Links",
    action: "Click Social Media IN",
    label: "Instagram",
  },
  linkedin: {
    category: "Social Links",
    action: "Click Social Media LI",
    label: "Linkedin",
  },
  x: {
    category: "Social Links",
    action: "Click Social Media X",
    label: "X",
  },
  login: {
    category: "Login",
    action: "Professional Login",
    label: "Professional Login",
  },
  match_successful: {
    category: "Lead Match",
    action: "Match Successful",
    label: "Match Successful",
  },
  match_unsuccessful: {
    category: "Lead Match",
    action: "Match UnSuccessful",
    label: "Match UnSuccessful",
  },
  pending_match: {
    category: "Lead Match",
    action: "Pending Match",
    label: "Pending Match",
  },
  enroll_as_provider: {
    category: "Enroll As Provider",
    action: "Click Enroll As Provider",
    label: "Enroll As Provider",
  },
  match_lead: {
    category: "Find Match",
    action: "Home Lead Match Start",
    label: "Home Lead Match Start",
  },
  match_button_fold: {
    category: "Find Match",
    action: "Click Find My Match Button",
    label: "Find My Match Button",
  },
  form_step_services: {
    category: "Lead Match",
    action: "Form Step Services",
    label: "Form Step Services",
  },
  form_step_custom: {
    category: "Lead Match",
    action: "Form Step Custom",
    label: "Form Step Custom",
  },
  form_step_insurance_1: {
    category: "Lead Match",
    action: "Form Step Insurance 1",
    label: "Form Step Insurance 1",
  },
  form_step_insurance_2: {
    category: "Lead Match",
    action: "Form Step Insurance 2",
    label: "Form Step Insurance 2",
  },
  form_step_email: {
    category: "Lead Match",
    action: "Form Step Email",
    label: "Form Step Email",
  },
  form_step_contact: {
    category: "Lead Match",
    action: "Form Step Contact Info",
    label: "Form Step Contact Info",
  },
};

export const handleEventAnalytics = (type) => {
  return analyticsObj[type];
};

export const handleProfessionalVisit = (name) => {
  return {
    category: "LP Profession",
    action: `LP ${name} Visit`,
    label: `LP ${name} Visit`,
  };
};
